import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_08_Interface } from 'src/app/Interface/DataEntity/08/DataEntity_Detail_08_Interface';
import { DataEntity_Main_08_Interface } from 'src/app/Interface/DataEntity/08/DataEntity_Main_08_Interface';
import { DataEntity_Resolution_08_Interface } from 'src/app/Interface/DataEntity/08/DataEntity_Resolution_08_Interface';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DataEntity08Service {

  constructor(private http: HttpClient) { }

  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno08/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_08_Interface,
    detail: Array<DataEntity_Detail_08_Interface>,
    resolution: Array<DataEntity_Resolution_08_Interface>,

    DataEntity_id: number,
    Calibration_Id: number,
    Filename: string,

    FolderName: string,

    Capability: string,
    DeviceSerial: string,
    DeviceCode: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    LabAddress_txt: String,


    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var detail_list = []
    var mesured_list = []


    for (let item of detail) {
      detail_list.push({
        id: item.id,
        main_id: model_temp.id,

        reference_Value: item.reference_Value,
        indication: item.indication,
        correction: item.correction,
        uncertainty: item.uncertainty,
        converage: item.converage,


        reference_Value_2: item.reference_Value_2,
        indication_2: item.indication_2,
        correction_2: item.correction_2,
        uncertainty_2: item.uncertainty_2,
        converage_2: item.converage_2,
      })
    }

    var model={
      id:model_temp.id,
      filename: Filename,

      pdf_src: FolderName,

      manufacture: Manufacture_txt,
      type: Type_txt,
      model: Model_txt,

      capability: Capability,
      before: model_temp.before==1,



      unit_Brix: model_temp.unit_Brix,
      unit_nD: model_temp.unit_nD,
      
      working: model_temp.working,
      reference_temperature: model_temp.reference_temperature,

      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

    }

    var body = {
      Calibration_id: Calibration_Id,
      dataentity_id: DataEntity_id,
      model: model,
      resolution : resolution,
      detail: detail_list,
      mesured: mesured_list,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      Token: Token,
      labAdderss: LabAddress_txt,

    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno08/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno08/upload?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno08/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }


}
